export const updateProfessionalDetailsUpdateApi = (data) => {    
    return data.data;
}
export const userProfessionalInfoGetApi = (data) => {    
    return data.data;
}